import module from 'finanzas/module.js'
import template from './template.html'

class FinancesPosicionbancariaEstatusComponent {
  constructor () {
    this.idMoneda = '1'
    this.fecha = new Date()
  }
}

module.component('financesPosicionbancariaEstatus', {
  controller: FinancesPosicionbancariaEstatusComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/estatus/component.js